import React, { useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/Button Triangle.png";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import { format, parse } from "date-fns";
import FilterIcon from "../../assets/Icons/Orange Filter.png";
import CrossIcon from "../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../assets/Icons/Left circle B.png";
import RightCircle from "../../assets/Icons/Right circle A.png";

const serviceType = [
  { value: "1", label: "Dr" },
  { value: "2", label: "Cr" },
  { value: "3", label: "All" },
];

const LedgeFilterModal = ({
  show,
  handleClose,
  setLedgerData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
  filterData,
  setFilterData,
  handleReset,
}) => {
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: {
      ...filterData,
      companyId: filterData.companyId || "",
      fromAmount: filterData.fromAmount || "",
      toAmount: filterData.toAmount || "",
      drcr: filterData.drcr || null,
      fromDate: filterData.fromDate || "",
      toDate: filterData.toDate || "",
      txnType: filterData.txnType || [],
    },
    mode: "onChange",
  });

  const [selectedTab, setSelectedTab] = useState("Company ID");
  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = (data) => {
    setFilterData(data);
    fetchCustomerData(currentPage, data);
  };

  const fetchCustomerData = async (page, formData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        ...formData,
        drcr: formData.drcr?.label || "",
        fromDate: formatDate(formData.fromDate),
        toDate: formatDate(formData.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_LEDGER_MASTER_DATA}?&pageSize=${pageSize}&pageNo=${page}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const modifiedData = modifyStructure(response?.data?.data);
        setLedgerData(modifiedData);
        setNoData(modifiedData?.length === 0);
        handleClose();
      } else {
        CustomAlert({
          title: "Failed",
          text:
            response?.data?.message ||
            "There was an issue processing the request.",
          icon: "error",
          confirmButtonText: "Retry",
        });
        setLedgerData([]);
        setNoData(true);
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    const modified = response?.map((user, index) => {
      const transDateParsed = user?.txnDate
        ? parse(user.txnDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const CreatedDateParsed = user?.createdDate
        ? parse(user.createdDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const formattedAmount =
        user?.amount !== undefined ? Number(user.amount).toFixed(2) : "";

      const formattedRrn = user?.rrn ? (
        <td
          style={{
            whiteSpace: "nowrap",
            overflow: "visible",
            textOverflow: "clip",
          }}
        >
          {user?.rrn}
        </td>
      ) : (
        ""
      );

      return {
        ...user,
        id: index + 1,
        txnDate: transDateParsed
          ? [
              format(transDateParsed, "dd-MM-yyyy"),
              <br key={index} />,
              format(transDateParsed, "HH:mm:ss"),
            ]
          : "",
        createdDate: CreatedDateParsed
          ? [
              format(CreatedDateParsed, "dd-MM-yyyy"),
              <br key={index} />,
              format(CreatedDateParsed, "HH:mm:ss"),
            ]
          : "",
        rrn: formattedRrn ? formattedRrn : "",
        amount: formattedAmount,
      };
    });

    return modified;
  };

  const onReset = () => {
    reset({
      companyId: "",
      fromAmount: "",
      toAmount: "",
      drcr: null,
      fromDate: "",
      toDate: "",
      txnType: [],
    });
    setFilterData({
      companyId: "",
      fromAmount: "",
      toAmount: "",
      drcr: null,
      fromDate: "",
      toDate: "",
      txnType: [],
    });
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[100px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                {/* <h5 className="modal-title main-title">Filter</h5> */}
                <div className="flex items-center gap-2">
                  <img src={FilterIcon} alt="filter icon" className="w-6 h-6" />
                  <h5 className="modal-title main-title font-medium">
                    Filters
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {[
                        "Company ID",
                        "Amount",
                        "Created Date",
                        "Debit/Credit",
                        "Transaction Type",
                      ].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content !bg-[linear-gradient(to_bottom,#FFE8D4_0%_100%,transparent_25%_100%)]">
                      {selectedTab === "Company ID" && (
                        <Controller
                          name="companyId"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Company ID</label>
                              <div className="dateInputWrapper">
                                <input
                                  {...field}
                                  type="text"
                                  placeholder="Enter Company ID"
                                  className="dateInput"
                                  maxLength={20}
                                  pattern="[A-Za-z0-9]+"
                                  onChange={(e) => {
                                    const val = e.target.value.replace(
                                      /[^a-zA-Z0-9]/g,
                                      ""
                                    );
                                    field.onChange(val);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      companyId: val,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {selectedTab === "Amount" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromAmount"
                            control={control}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Amount</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="number"
                                    placeholder="0.00"
                                    min="0"
                                    onKeyDown={(e) => {
                                      if (
                                        e.key === "-" ||
                                        e.key === "+" ||
                                        e.key === "e"
                                      )
                                        e.preventDefault();
                                    }}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (
                                        /^\d*\.?\d*$/.test(val) ||
                                        val === ""
                                      ) {
                                        field.onChange(val);
                                        setFilterData((prev) => ({
                                          ...prev,
                                          fromAmount: val,
                                        }));
                                      }
                                    }}
                                    className="dateInput"
                                  />
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toAmount"
                            control={control}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Amount</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="number"
                                    placeholder="0.00"
                                    min="0"
                                    onKeyDown={(e) => {
                                      if (
                                        e.key === "-" ||
                                        e.key === "+" ||
                                        e.key === "e"
                                      )
                                        e.preventDefault();
                                    }}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (
                                        /^\d*\.?\d*$/.test(val) ||
                                        val === ""
                                      ) {
                                        field.onChange(val);
                                        setFilterData((prev) => ({
                                          ...prev,
                                          toAmount: val,
                                        }));
                                      }
                                    }}
                                    className="dateInput"
                                  />
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}

                      {selectedTab === "Created Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value, formValues) =>
                                  !value ||
                                  !formValues.toDate ||
                                  new Date(value) <=
                                    new Date(formValues.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, formValues) =>
                                  !formValues.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <div className="error-text">
                                      {errors.fromDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value, formValues) =>
                                  !value ||
                                  !formValues.fromDate ||
                                  new Date(value) >=
                                    new Date(formValues.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, formValues) =>
                                  !formValues.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <div className="error-text">
                                      {errors.toDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}

                      {selectedTab === "Debit/Credit" && (
                        <Controller
                          name="drcr"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Debit/Credit</label>
                              <div className="dateInputWrapper">
                                <select
                                  {...field}
                                  value={field.value?.value || ""}
                                  onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    const selectedOption = serviceType.find(
                                      (opt) => opt.value === selectedValue
                                    );
                                    field.onChange(selectedOption || null);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      drcr: selectedOption || null,
                                    }));
                                  }}
                                  className="dateInput"
                                >
                                  <option value="" disabled>
                                    Select Option
                                  </option>
                                  {serviceType.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {selectedTab === "Transaction Type" && (
                        <div className="dateField">
                          <label
                            className="dateLabel"
                            style={{
                              marginBottom: "0.5rem",
                              fontWeight: "600",
                              fontSize: "20px",
                            }}
                          >
                            Transaction Type
                          </label>
                          <div
                            className="dateInputWrapper"
                            style={{
                              display: "flex",
                              gap: "1rem",
                              flexWrap: "wrap",
                              padding: "0.75rem",
                              backgroundColor: "#ffdab8",
                              border: "1px solid #ced4da",
                              borderRadius: "0.5rem",
                            }}
                          >
                            {[
                              { label: "RCS", value: "rcs" },
                              { label: "SMS", value: "sms" },
                              { label: "Top-up", value: "topUp" },
                              { label: "Reversal", value: "reversal" },
                              { label: "Courier", value: "courier" },
                              { label: "Recharge", value: "recharge" },
                            ].map((status) => (
                              <label
                                key={status.label}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  padding: "0.5rem 0.75rem",
                                  borderRadius: "0.375rem",
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={filterData.txnType.includes(
                                    status.label
                                  )}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const newTxnType = isChecked
                                      ? [...filterData.txnType, status.label]
                                      : filterData.txnType.filter(
                                          (v) => v !== status.label
                                        );
                                    setValue("txnType", newTxnType);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      txnType: newTxnType,
                                    }));
                                  }}
                                  style={{ cursor: "pointer" }}
                                />
                                {status.label}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back !rounded-lg w-[133px]"
                      onClick={onReset}
                    >
                      Clear
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      onClick={handleSubmit(onSubmit)}
                      className="btn btn-submit !rounded-lg w-[133px]"
                      disabled={loading}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Apply"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LedgeFilterModal;
